import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Validator } from '../../../../../utils/Validator.util';
import { namespace } from 'vuex-class';
import { PROFILE_CHANGE_EMAIL, PROFILE_MODULE_NAMESPACE } from '../../../../../store/profile/profile-types.store';

const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)
@Component
class EmailModificationModal extends Vue {

  @Prop({ default: false, type: [Boolean] })
  visible: boolean;


  @Prop({ required: true, type: [String] })
  email: string;

  dtPassword: string;
  dtEmail: string;
  dtLoading: boolean;
  dtError: any;
  dtSuccess: boolean;
  dtRules: any;
  dtPasswordMode: "password" | "text";
  /**
   *
   */
  constructor() {
    super();
    this.dtLoading = false;
    this.dtSuccess = false;
    this.dtPassword = "";
    this.dtEmail = "";
    this.dtError = null;
    this.dtRules = {
      require: (value: string) => !!value || 'Required.',
      email: (value: string) => (Validator.IsValidEmail(value) && value !== this.email) || 'l\'email n\'est pas valide',
      differenceEmail: null
    }
    this.dtPasswordMode = "password"
  }
  mounted() {
    this.dtRules.differenceEmail = (value: string) => value !== this.email || 'Email must be not the same'
  }
  get coVisible(): boolean {
    return this.visible;
  }
  set coVisible(value: boolean) {
    this.$emit('update:visible', value)
  }


  @ProfileStore.Action(PROFILE_CHANGE_EMAIL)
  storeChangeEmail: (payload: { email: string, password: string }) => Promise<any>

  _clearTimeout: any
  handleSave() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(async () => {
      this.dtLoading = true;
      this.dtError = null;
      await this.storeChangeEmail({ email: this.dtEmail, password: this.dtPassword })
        .then(res => {
          this.dtLoading = false
          this.dtSuccess = true
        })
        .catch(err => {
          this.dtLoading = false
          this.dtError = err;
        })
    }, 300);
  }

  resetValues() {
    this.dtEmail = "";
    this.dtError = null;
    this.dtPassword = "";
  }

  handleConfirm() {
    this.dtSuccess = false;
    setTimeout(() => {
      this.resetValues();
      this.coVisible = false;
    }, 100);
  }
  handleOnClose() {
    this.dtSuccess = false;
    this.resetValues();
  }

  handleShowPassword() {
    this.dtPasswordMode = this.dtPasswordMode === "password" ? "text" : "password"
  }
}

export default EmailModificationModal;


// WEBPACK FOOTER //
// ./src/containers/profile/profile-child-account/components/email-motification-modal/index.ts